

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import store from './store'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {browserMobile} from './common/js/util'
import VueClipboards from 'vue-clipboard2'
import filters from './common/js/formatTime.js'
Vue.use(VueClipboards);




Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
})
Vue.directive('transfer-dom', TransferDom)

Vue.use(VueRouter)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
loading: require('@/common/image/default_image_normal.png'),
error: require('@/common/image/default_image_normal.png')
})


import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)

FastClick.attach(document.body)
Vue.config.productionTip = false

setTimeout(()=>{
if(browserMobile().isPc){
if(window.location.pathname == '/LearnDetail'){
window.open(window.location.origin+'/video.html'+window.location.search,'_self')
}
}
},200);

router.afterEach((to, from) => {
if(browserMobile().isPc){

}

var _hmt = _hmt || [];
(function() {
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?26c3b4a3eb651f6cf93b307c1d58fceb";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);

})();


})


/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js